import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import type * as React from 'react';

type Props = {
    open: boolean;
    onClose: () => void;
};

const HelpDialog: React.FC<Props> = ({open, onClose}: Props) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
            <DialogTitle>Help</DialogTitle>
            <DialogContent>
                <Typography variant='h6'>Sign out</Typography>
                <Typography gutterBottom>
                    Signs you out and clears the downloaded ID from your device.
                </Typography>

                <Typography variant='h6'>Refresh ID</Typography>
                <Typography gutterBottom>
                    Refreshes your currently downloaded ID (Requires active internet connection).
                </Typography>

                <Typography variant='h6'>Submit new photo for review</Typography>
                <Typography gutterBottom>
                    Take or upload photo to be reviewed by the Dean's Office (Requires active
                    internet connection). You will receive an email when the photo is either
                    approved or rejected.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button color='primary' onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default HelpDialog;
